/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { CalendarCheck, RefreshCcw, ShieldAlert } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';
const NS = '/bff/v1/j06-s02-validar-disponibilidade';
export function ValidarDisponibilidadeOsPage() {
  const [s, setS] = useState<any>();
  const [erro, setErro] = useState('');
  async function call(path: string, body?: any) {
    try {
      const r = await chamarApi<any>(NS + path, {
        metodo: path === '/state' ? 'GET' : 'POST',
        corpo: body,
      });
      setS(r.state);
      setErro('');
    } catch {
      setErro('Não foi possível consultar a validação.');
    }
  }
  useEffect(() => {
    void call('/state');
  }, []);
  if (!s)
    return (
      <main role="status" className="p-6">
        Carregando validações…
      </main>
    );
  return (
    <main className="min-w-0 max-w-[calc(100vw-2rem)] space-y-5 overflow-hidden">
      <header>
        <h1 className="text-3xl font-semibold">{s.titulo}</h1>
        <p>{s.descricao}</p>
      </header>
      {(erro || s.alertas?.length > 0) && (
        <div role="alert" className="rounded-md border border-destructive p-3">
          {erro || s.alertas[0].mensagem}
        </div>
      )}
      <section className="space-y-3" aria-label="Ordens para validação">
        {s.ordens.length === 0 ? (
          <p className="rounded-md border p-5">Nenhum rascunho disponível.</p>
        ) : (
          s.ordens.map((o: any) => (
            <article key={o.id} className="rounded-md border p-4">
              <h2 className="font-semibold">
                <CalendarCheck className="mr-2 inline h-5 w-5" />
                OS #{o.numero} · revisão {o.revisao}
              </h2>
              <p>
                {o.inicio} a {o.fim} · validação {o.validacao?.status ?? 'não executada'} · reserva{' '}
                {o.reserva?.status ?? 'ausente'}
              </p>
              {o.validacao?.conflitos?.length > 0 && (
                <ul className="mt-2 list-disc pl-5">
                  {o.validacao.conflitos.map((c: any) => (
                    <li key={c.codigo}>
                      <strong>{c.campo}:</strong> {c.mensagem}
                    </li>
                  ))}
                </ul>
              )}
              <div className="mt-3 flex flex-wrap gap-2">
                <Button
                  onClick={() =>
                    void call('/verbs/validar_disponibilidade', {
                      ordemServicoId: o.id,
                      chaveIdempotencia: `j06-s02-validar-${o.id}-r${o.revisao}`,
                    })
                  }
                >
                  <ShieldAlert className="mr-2 h-4 w-4" />
                  Validar e reservar
                </Button>
                {o.validacao?.status === 'LIBERADA' && (
                  <Button
                    variant="outline"
                    onClick={() =>
                      void call('/verbs/invalidar_por_alteracao', {
                        ordemServicoId: o.id,
                        observacoes: 'Período ou referência alterado após a validação.',
                      })
                    }
                  >
                    <RefreshCcw className="mr-2 h-4 w-4" />
                    Alterar e invalidar
                  </Button>
                )}
              </div>
            </article>
          ))
        )}
      </section>
    </main>
  );
}
